import React from "react";
import { Spinner } from "react-rainbow-components";
import ChatItem from "../ChatItem";
import { ContainerChat } from "./index.style";
import useChatRoom from "./useChatRoom";
interface Props {
  uid: string;
  startDate?: number | string | Date;
  imageUrl: string;
}

export default function ChatRoom(props: Props) {
  const { isLoading, chats, messagesEndRef } = useChatRoom(props);
  return (
    <ContainerChat>
      {!isLoading ? (
        chats.map((item) => {
          return (
            <ChatItem
              {...item}
              isMe={item.doctorId}
              avatarUser={props.imageUrl}
              key={item.id}
            />
          );
        })
      ) : (
        <Spinner />
      )}
      <div ref={messagesEndRef} />
    </ContainerChat>
  );
}
